import isFullArray from 'utils/predicates/array/isFullArray.util';

const fromSegmentsToPath = (segments) => (isFullArray(segments) ? segments.join('/') : '');

// noinspection JSUnusedGlobalSymbols
export default fromSegmentsToPath;
